module.exports = __webpack_public_path__ + "img/icon_2colum_centralita_02.4743eb9a.png";